(function () {
  function closeTips(except) {
    document.querySelectorAll('.kpc-artist-tip.is-active').forEach(function (tip) {
      if (tip === except) return;
      tip.classList.remove('is-active');
      var btn = document.querySelector('[aria-controls="' + tip.id + '"]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.kpc-artist-btn');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      var tip = document.getElementById(btn.getAttribute('aria-controls'));
      if (!tip) return;
      closeTips(tip);
      var open = tip.classList.toggle('is-active');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (!e.target.closest('.kpc-artist-tip')) closeTips();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeTips();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.classList && form.classList.contains('kpc-form')) {
      var b = form.querySelector('button');
      if (b) {
        b.classList.add('is-loading');
        b.setAttribute('aria-busy', 'true');
        var label = b.querySelector('span');
        if (label) label.textContent = 'Aggiungo...';
      }
    }
  });
})();